// src/extenders/remove-filter.js
var RemoveFilter = class extends HTMLElement {
  constructor() {
    super();
    this.removeButton = this.querySelector(".filter-chip-button");
    this.section = null;
  }
  connectedCallback() {
    this.section = this.closest(".shopify-section");
    if (!this.section) {
      return;
    }
    this.removeButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.getAttribute("data-action") === "reset-filters") {
        const isMobile = this.removeButton.closest("form") !== null;
        this.removeButton.closest("collection-filter-form").resetFilters(isMobile);
        return;
      }
      const selector = `input[name="${this.getAttribute("data-filter-name")}"][value="${this.getAttribute("data-filter-value")}"]`;
      let form = this.removeButton.closest("form");
      if (!form) {
        form = this.section.querySelector(".filter-form-desktop");
      }
      form.querySelector(selector).click();
      if (form.classList.contains("filter-form-mobile")) {
        form.querySelector('[type="submit"]').click();
      }
    });
  }
};
if (!customElements.get("remove-filter")) {
  customElements.define("remove-filter", RemoveFilter);
}
